import './AppStatusTable.scss';
import { AppStatusMessage } from './AppStatusMessage';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { getColumns } from './AppStatusTableColumns';
import { queryParamsToDynamicQueryLanguageParams } from '@sonar-software/sonar-ts-lib';
import { SonarCard } from '@ui/general';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import { PaginatedTable } from '@ui/tables/PaginatedTable';
import React, { useMemo, useState } from 'react';
import { useAction, useAsyncState, useFeatureFlag, useOnMount, usePrevious, useQueryParams } from '@hooks';
const getRowKey = (result) => `${result.applicationName}-${result.applicationLabel}`;
const dataSecurityAppStatusSelectors = createAsyncSelectors((state) => state.core.dataSecurity.appStaus.get);
const convertToDql = (params) => queryParamsToDynamicQueryLanguageParams(params, {
    filterParams: { applicationId: true }
});
export const AppStatusTable = ({ applicationId }) => {
    var _a, _b;
    const getAppStatus = useAction(coreActions.requestGetCoreDataSecurityAppStatus);
    const [firstLoad, setFirstLoad] = useState(true);
    const previousApplicationId = usePrevious(applicationId);
    const applicationIdChanged = applicationId !== previousApplicationId;
    const isEnabled = useFeatureFlag(FeatureFlag.DataSecurityApplicationStatus);
    const { data, isRequested } = useAsyncState(dataSecurityAppStatusSelectors);
    const statusLink = Number.isInteger(applicationId) ? (_a = data === null || data === void 0 ? void 0 : data.results[0]) === null || _a === void 0 ? void 0 : _a.statusPageUrl : undefined;
    const statusMessage = Number.isInteger(applicationId) ? (_b = data === null || data === void 0 ? void 0 : data.results[0]) === null || _b === void 0 ? void 0 : _b.errorMessage : undefined;
    const { queryParams, updateParams } = useQueryParams({
        defaultParams: {
            applicationId,
            count: 10
        },
        onUpdate: () => {
            getAppStatus(convertToDql(queryParams));
        }
    });
    useOnMount(() => {
        setFirstLoad(false);
        getAppStatus(convertToDql(queryParams));
    });
    const columns = useMemo(() => getColumns(!Number.isInteger(applicationId)), [applicationId]);
    if (!isEnabled) {
        return null;
    }
    return (React.createElement(SonarCard, { className: 'app-status-table', loading: firstLoad || applicationIdChanged, noSpacing: true, title: COPY_SPECIFIC.APPLICATION_STATUS, titleClassName: 'h2', useSpinnerLoading: true },
        React.createElement("div", { className: 'table-container' },
            React.createElement(PaginatedTable, { autohidePagination: true, columns: columns, defaultPageSize: 10, id: 'app-status-table', loading: isRequested, onChange: updateParams, resource: data, rowKey: getRowKey, showSizeChanger: false, sortBy: queryParams.sortBy, sortDirection: queryParams.sortDirection })),
        React.createElement(AppStatusMessage, { link: statusLink, message: statusMessage })));
};
